import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
  mutation updateUser($user: UserInput!) {
    updateUser(user: $user) {
      email
      firstname
      lastname
      gender
      address
      zipCode
      city
      country
      workplace
      language
      card {
        last4
      }
    }
  }
`;

export const SET_NEW_PASSWORD = gql`
  mutation updatePassword($password: String!, $newPassword: String!) {
    setNewPassword(password: $password, newPassword: $newPassword) {
      id
    }
  }
`;

export const SUBSCRIBE = gql`
  mutation subscribeUser($voucher: String, $productId: Int) {
    subscribe(voucher: $voucher, productId: $productId) {
      id
      duration
      renew
      price
      currency
      period
      periodUnit
    }
  }
`;

export const UPDATE_SUBSCRIPTION = gql`
  mutation updateSubscription($productId: Int!) {
    updateSubscriptionProduct(productId: $productId) {
      id
      duration
      renew
      price
      currency
      period
      periodUnit
    }
  }
`;

export const UNSUBSCRIBE = gql`
  mutation unSubscribeUser($id: ID!) {
    unsubscribe(id: $id) {
      id
      duration
      renew
      price
      currency
      period
      periodUnit
    }
  }
`;

export const GET_SUBSCRIPTION = gql`
  query getSubscription {
    subscription {
      id
      duration
      renew
      price
      currency
      period
      periodUnit
    }
  }
`;

export const REQUEST_EMAIL_UPDATE = gql`
  mutation requestEmailUpdate($email: String!) {
    requestEmailUpdate(email: $email)
  }
`;

export const EMAIL_UPDATE = gql`
  mutation updateEmail($code: Int!) {
    updateEmail(code: $code) {
      email
      sessionToken
    }
  }
`;

export const GET_PAYMENTS = gql`
  query getPayments {
    payments {
      id
      name
      price
      currency
      card
      createdAt
    }
  }
`;

export const GET_INVOICE = gql`
  query getInvoice($id: ID!) {
    invoice(id: $id)
  }
`;

export const GET_NEWSLETTER_LIST = gql`
  query getNewsletterList {
    app {
      id
      newsletter {
        id
        name
      }
    }
  }
`;

export const SET_NEWSLETTERS = gql`
  mutation updateNewsletter($email: String!, $privacy: PrivacyInput!) {
    updateNewsletter(email: $email, privacy: $privacy) {
      id
      privacy {
        notifications
        publicProfile
        newsletter
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser {
    deleteUser {
      id
    }
  }
`;

export const GET_VOUCHER_CODE = gql`
  query getVoucherCode($id: ID!) {
    user(id: $id) {
      voucherCode
    }
  }
`;

export const BUY_CREDITS = gql`
  mutation Purchase($id: Int!, $price: Int, $paymentOption: String!) {
    purchase(id: $id, price: $price, paymentOption: $paymentOption) {
      id
    }
  }
`;

export const SUBSCRIBE_TO_NEWS = gql`
  mutation SubscribeToNews($email: String!) {
    subscribeToNewsletter(email: $email)
  }
`;
